import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from './simulatedContentMapMessages';
import './SimulatedContentMapAbilityButton.scss';

const SimulatedContentMapAbilityButton = props => {
  switch (Number(props.status)) {
    case 0:
      if (props.isCoordinator.edit === 1) {
        return (
          <React.Fragment>
            <button className="content-map--edit-button edit-card-edit" onClick={props.onEdit}>
              <i className="ti-pencil" />
              <FormattedMessage {...messages.edit} />
            </button>
            <button className="content-map--edit-button edit-card-remove" onClick={props.onDelete}>
              <i className="ti-trash" />
              <FormattedMessage {...messages.delete} />
            </button>
          </React.Fragment>
        );
      }
      return null;
    case 1:
      return (
        <button className="content-map--edit-button edit-card-reload">
          <i className="ti-reload" />
          <FormattedMessage {...messages.analysing} />
        </button>
      );
    case 2:
      return (
        <React.Fragment>
          <button className="content-map--edit-button edit-card-approve" onClick={props.onApprove}>
            <i className="ti-check" />
            <FormattedMessage {...messages.approve} />
          </button>
          <button className="content-map--edit-button edit-card-reprove" onClick={props.onReprove}>
            <i className="ti-close" />
            <FormattedMessage {...messages.reprove} />
          </button>
        </React.Fragment>
      );
    case 3:
      return (
        <button className="content-map--edit-button edit-card-approve-waiting">
          <i className="fa fa-check-circle" />
          <FormattedMessage {...messages.approvedWaiting} />
        </button>
      );
    case 4:
      return (
        <button className="content-map--edit-button edit-card-done" onClick={props.onVisualize}>
          <i className="fa fa-check-circle" />
          <FormattedMessage {...messages.done} />
        </button>
      );
    case 5:
      return (
        <React.Fragment>
          <button className="content-map--edit-button edit-card-reproved">
            <i className="ti-closed" />
            <FormattedMessage {...messages.reproved} />
          </button>
          <button className="content-map--edit-button edit-card-remove" onClick={props.onDelete}>
            <i className="ti-trash" />
            <FormattedMessage {...messages.delete} />
          </button>
        </React.Fragment>
      );
    case 6:
      return (
        <button className="content-map--edit-button edit-card-reproved">
          <i className="ti-closed" />
          <FormattedMessage {...messages.reproved} />
        </button>
      );

    default:
      return <div />;
  }
};

SimulatedContentMapAbilityButton.propTypes = {};

SimulatedContentMapAbilityButton.defaultProps = {
  status: 0,
};

export default SimulatedContentMapAbilityButton;
